import React from "react";

import Modal from 'react-modal';

function ExampleReactComponent({modalIsOpen = false, onClose}) {

    return (

        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => {
                if (onClose) {
                    onClose();
                }
            }}
            className="model-custom"
            contentLabel="Example Modal"
        >
            <section className="page">
                <div className="container ">
                    <div className="page-text ">
                        <div className="section-header text-center">
                            <h1 style={{fontSize: "4rem"}}>CONTACT US</h1>
                        </div>


                        <form   autoComplete="off" id="contact_form" accept-charset="UTF-8"
                             className="contact-form">

                            <input type="hidden" name="form_type" value="contact"/>
                            <input
                            type="hidden" name="utf8" value="✓"/>


                            <div className="grid">
                                <div className="grid__item medium-up--one-half">
                                    <label htmlFor="ContactFormName" className="label--hidden">Name</label>
                                    <input   autoComplete="off" type="text" id="ContactFormName" name="contact[Name]" placeholder="Name"
                                           autoCapitalize="words"  value=""/>
                                </div>
                                <div className="grid__item medium-up--one-half">
                                    <label htmlFor="ContactFormEmail" className="label--hidden">Email</label>
                                    <input   autoComplete="off" type="email" id="ContactFormEmail" name="contact[email]" placeholder="Email"
                                           autoCorrect="off" autoCapitalize="off"  value=""/>
                                </div>
                            </div>

                            <label htmlFor="ContactFormPhone" className="label--hidden">Phone Number</label>
                            <input type="tel" id="ContactFormPhone" name="contact[Phone Number]"
                                   placeholder="Phone Number" autoComplete="off" pattern="[0-9\-]*" value=""/>

                            <label htmlFor="ContactFormMessage" className="label--hidden">Message</label>
                            <textarea rows="6" id="ContactFormMessage" autoComplete="off" name="contact[Message]"
                                      placeholder="Message"></textarea>

                            <input
                                className="btn btn-def"
                                value="Cancel"
                                onClick={() => {
                                    if (onClose) {
                                        onClose();
                                    }
                                }}
                                style={{marginRight: "1rem", backgroundColor: "#000", color: "#fff", width: "15rem"}}
                            />
                            <input onClick={()=>{
                                if (onClose) {
                                    onClose();
                                }
                            }} type="submit" className="btn btn-def" value="Send"/>
                        </form>
                    </div>
                </div>
            </section>
        </Modal>
    );
}

export default ExampleReactComponent;
